export type CairoTranslations = Partial<
  typeof import('../assets/locale/messages_en.json')
>;

// `vite` imports JSON with `default` namespace
export type CairoTranslationsOrDefault =
  | (CairoTranslations & { default?: undefined })
  | { default: CairoTranslations };
